export default __webpack_public_path__ + "static/media/not.e0c3852e.PNG";